import mainLogo from '../../images/Luson/luson_logo_color.png';
import squareLogo from '../../images/Luson/luson_logo_vertical_color.png';
import bannerLogoWhite from '../../images/Luson/luson_logo_white.png';
import banner01 from '../../images/Luson/luson_bg_06.jpg';
import banner02 from '../../images/Luson/luson_bg_09.jpg';
import banner03 from '../../images/Luson/luson_bg_07.jpg';
import banner04 from '../../images/Luson/luson_bg_08.jpg';
import car123 from '../../images/Luson/123_virtus.jpg';
import box123 from '../../images/Luson/123_luson.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Luson',
    defaultStoreLink: 'lojaluson.com.br',
    defaultContactEmail: 'ecommerce@luson.com.br',
    whatsappNumber: '41 98527 1954',
    CNPJname: 'Luson Veiculos LTDA',
    CNPJ: '78.453.669/0001-26',
    CNPJaddress: 'Av. das Torres, 1607 - São Cristóvão, São José dos Pinhais, Curitiba-PR - 83.040-300',
    launchDate: '07/09/2024',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        'volkswagen',
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "LUSON VW",
        "LUSON VW TARUMA",
    ],

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1200: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
        },
        {
            name: 'Pneus',
            img: 'tabPneus',
            products: SliderProducts.Pneus
        },
        {
            name: 'Roupas',
            img: 'tabRoupas',
            products: SliderProducts.Roupas
        }
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: bannerLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    banner04: banner04,
    bannerBrands: '',
    aboutUsBg: banner04,

    box123: box123,
    car123: car123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerSpecial: '',
    bannerSpecialMobile: '',
    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças originais <span style="font-weight: bold;">Volkswagen</span> direto das concessionárias <span style="font-weight: bold;">Luson</span>.',
    aboutUs: {
        title: 'Quem somos',
        content: [
            'A Luson Veículos iniciou suas atividades no dia 20 de abril de 1994, na Rua Isabel Redentora no Centro do Munícipio de São José dos Pinhais, PR. Após 3 anos de sucesso, a nova sede foi inaugurada no dia 13 de junho de 1997, na Avenida das Torres, 1607 com uma ampla área construída de 7000 m², possibilita espaços internos suficientes para oferecer comodidade e conforto a seus clientes. Serviços de mecânica, funilaria e pintura localizados em piso exclusivo.',
        ],
        link: 'https://luson.com.br/institucional',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/lusonvolkswagen/',
        Facebook: 'https://www.facebook.com/LusonVeiculosLTDA/',
        LinkedIn: 'https://www.linkedin.com/company/luson/?originalSubdomain=pt',
        Youtube: 'https://www.youtube.com/channel/UCL19fy0rjquKJSwZb-NitZw/videos',
        Twitter: '',
    },

    footerContent: [],
}